// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyCLDl77zbhZi41eJGIYIXsWPHLNiNG6ZCo",
    authDomain: "generacion-mezcal.firebaseapp.com",
    projectId: "generacion-mezcal",
    storageBucket: "generacion-mezcal.firebasestorage.app",
    messagingSenderId: "74798421719",
    appId: "1:74798421719:web:c42891119467ba218dc292",
    measurementId: "G-50S3MF0J87"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)